import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const MetaPixelTracker = () => {
  const location = useLocation();

  useEffect(() => {
    if (!window.fbq) return;

    const page = location.pathname;
    const pagePath = page + location.search;

    // ✅ 1. Track every page view
    window.fbq("track", "PageView", {
      page_path: pagePath,
    });

    // ✅ 2. Custom event to know WHICH page was visited
    window.fbq("trackCustom", "VisitedPage", {
      page_name: page,
    });

    // ✅ 3. Funnel events (ONLY where meaningful)
    if (page === "/cart") {
      window.fbq("track", "AddToCart");
    }

    if (page === "/checkout") {
      window.fbq("track", "InitiateCheckout");
    }

    if (page === "/PaymentSuccess") {
      window.fbq("track", "PaymentSuccess", {
        value: 0, // replace later
        currency: "INR",
      });
    }
    if (page === "/PaymentFailed") {
      window.fbq("track", "PaymentFailed");
    }
    if (page === "/treatments") {
      window.fbq("track", "treatments");
    }
    if (page === "/consultation") {
      window.fbq("track", "consultation");
    }
    if (page === "/videos") {
      window.fbq("track", "videos");
    }
    if (page === "/blog") {
      window.fbq("track", "blog");
    }
    if (page === "/products") {
      window.fbq("track", "products");
    }
  }, [location.pathname, location.search]);

  return null;
};

export default MetaPixelTracker;
